export const ALT_TEXT_MAX = 1500;
